'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Pen = function Pen(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 14 14' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'title',
        null,
        'pen'
      ),
      _react2.default.createElement('path', { d: 'M13.712 4.533L11.84 6.396l-4.28-4.26L9.43.271a.934.934 0 0 1 1.317 0l2.964 2.95a.926.926 0 0 1 0 1.311zm-7.043 7.01L0 13.923l2.389-6.64 3.854-3.836 4.28 4.26-3.854 3.836zm-3.9-2.57l-1.228 3.415 3.43-1.223L2.77 8.973z',
        fill: 'currentColor', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

exports.default = Pen;
//# sourceMappingURL=Pen.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Pen.js